import { useInView } from 'react-intersection-observer';

import type React from 'react';

interface VisibleAnalyticsProps {
  /** 計測対象 */
  children: React.ReactNode;
  /** 計測関数 */
  onVisible: VoidFunction;
}

/**
 * 表示計測用コンポーネント
 */
export const VisibleAnalytics = (props: VisibleAnalyticsProps) => {
  const { children, onVisible } = props;
  const [ref] = useInView({
    triggerOnce: true,
    onChange: (inView) => {
      if (inView) onVisible();
    },
  });

  return <div ref={ref}>{children}</div>;
};
